// instructions: leave 1 account in accountName filter and 12 most recent months with data in date filter
const quotesByYearLine = {
  vals: ['quote'],
  cols: ['date'],
  dataScope: 'quotes',
  rows: ['displayName'],
  rendererName: 'Line chart, horizontal',
  rendererType: 'nivo', // 'nivo' requires a height property to be set on its parent to be displayed
  id: 'quoteByYearLinexxxxxx',
  name: 'Quotes snapshot, line chart, by year',
  aggregatorName: 'Sum',
  readOnly: true,
  // valueFilter: {
  //   category: {
  //     deposits: true,
  //     // stocks: true,  // skip value here to show it (not sure if this is the intended way, but works)
  //     realEstate: true,
  //     loans: true,
  //     metals: true,
  //     crypto: true,
  //     pension: true,
  //     objectsOfValue: true,
  //     unlistedShares: true,
  //   },
  // },
};

export default quotesByYearLine;
